import { useState, useEffect } from 'react';

/**
 * Hook para debounce - evita llamadas excesivas durante typing
 * ✅ FASE 4: Advanced optimization para búsquedas
 */
export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}